import { Directive, ElementRef, OnDestroy, OnInit, inject } from '@angular/core';
import { NgControl } from '@angular/forms';
import { InputNumber } from 'primeng/inputnumber';
import { fromEvent, Subscription } from 'rxjs';

/**
 * A directive to trap the focus event
 * on p-select and call the PrimeNG show and focus methods
 * IFF the control has errors.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'p-inputNumber',
})
export class CmgPrimeNgInputNumberFocusDirective implements OnInit, OnDestroy {
  private readonly _el = inject(ElementRef);
  private readonly _inputNumber = inject(InputNumber);
  private readonly _control = inject(NgControl);

  private _sub: Subscription;

  ngOnInit() {
    this._sub = fromEvent(this._el.nativeElement, 'focus').subscribe(() => {
      this._onInputNumberFocus();
    });
  }

  ngOnDestroy() {
    if (this._sub && !this._sub.closed) {
      this._sub.unsubscribe();
    }
  }

  private readonly _onInputNumberFocus = () => {
    // If the PrimeNG dropdown has errors and it is not already open, focus and open (show) it
    if (this._inputNumber && this._control?.status === 'INVALID') {
      const htmlCtrl = document.querySelector('#' + this._el.nativeElement.id + ' input');
      if (htmlCtrl) {
        setTimeout(
          (ctrl: HTMLElement) => {
            ctrl.focus();
          },
          10 /* half a sec seems to work always */,
          htmlCtrl,
        );
      }
    }
  };
}
